export const FEATURE_FLAG = {
  ENABLE_ANONYMOUS_FLOW: `enable-anonymous-flow`,
  HIDE_SALES_TOOLS_LEASING_RATE: `hide-sales-tools-leasing-rate`,
} as const;
